import TextField from "@mui/material/TextField";
import React from "react";

export default function DepartmentCell(props) {
  const { rowData, handleChange } = props;

  return (
    <>
      {rowData.showInput ? (
        <div className="flex-1 h-full w-[75%]">
          <div className="">
            <TextField
              InputProps={{
                style: {
                  borderRadius: "10px",
                },
              }}
              value={rowData.detail.department}
              onChange={(newValue) =>
                handleChange('department', newValue.target.value)
              }
              size="small"
              className="w-full"
              placeholder='部署名 (報告書には記載されません)'
            />
          </div>
          <div className="">
            <TextField
              InputProps={{
                style: {
                  borderRadius: "10px",
                },
              }}
              value={rowData.detail.picNameKanji}
              onChange={(newValue) =>
                handleChange('picNameKanji', newValue.target.value)
              }
              size="small"
              className="w-full"
              placeholder="氏名"
            />
          </div>
        </div>
      ) : (
        <div
          className="h-full w-[75%] border border-[#B3B3B3] bg-[#B3B3B3] bg-opacity-[26%] text-sm md:flex"
          style={{
            flex: 1,
            textAlign: rowData.textAlign || "start",
          }}
        >
          <div className="flex-1 max-w-[50%] border-b md:border-b-0 md:border-r border-[#B3B3B3] flex items-center">
            <p className="leading-[18px] tracking-[1.75px] truncate border-r border-[#B3B3B3] px-4 py-[10px]">
              部署名<br/>
              (報告書には<br/>
              記載されません)
            </p>
            <p className="leading-[18px] max-w-[calc(100%-150px)] tracking-[1.75px] truncate px-4 py-[10px]">
              {rowData.detail.department || "-"}
            </p>
          </div>
          <div className="flex-1 max-w-[50%] flex items-center">
            <p className="leading-[18px] tracking-[1.75px] truncate border-r border-[#B3B3B3] px-4 py-[10px] h-full flex items-center">
              氏名
            </p>
            <p className="leading-[18px]  max-w-[calc(100%-70px)] tracking-[1.75px] truncate px-4 py-[10px]">
              {rowData.detail.picNameKanji || "-"}
            </p>
          </div>
        </div>
      )}
    </>
  );
}